import AppSearchV2 from 'components/Search/FormV2/index.vue'

export default {
  name: 'box-not-found',

  props: {
    title: {
      required: false
    },
    message: {
      required: false
    },
    searchH1: {
      required: false,
      type: Boolean,
      default: false
    },
    searchTitle: {
      required: false,
      type: String
    }
  },

  data() {
    return {
      pathError: null
    }
  },

  components: {
    AppSearchV2
  },

  mounted() {
    this.pathError = this.$route.path
  },

  methods: {
    getTitle() {
      if (this.title) return this.title

      return `
        ${this.$t('errorpage.title')}
        <i class="material-icons">warning</i>
      `
    },

    getMessage() {
      if (this.message) return this.message

      return `
        <span>${this.$t('errorpage.thepagenotfound', { path: this.pathError })}</span>
        <span>${this.$t('errorpage.notfoundtext')}</span>
      `
    }
  }
}
